import React, { HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

interface IProperties extends HTMLAttributes<HTMLHeadingElement> {
  type: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

const Header = (properties: IProperties) => {
  const { children, type, className, ...remainingProperties } = properties;
  switch (type) {
    case 'h1': {
      return (
        <h1 {...remainingProperties} className={twMerge('text-4xl', className)}>
          {children}
        </h1>
      );
    }
    case 'h2': {
      return (
        <h2 {...remainingProperties} className={twMerge('text-3xl', className)}>
          {children}
        </h2>
      );
    }
    case 'h3': {
      return (
        <h3 {...remainingProperties} className={twMerge('text-2xl', className)}>
          {children}
        </h3>
      );
    }
    case 'h4': {
      return (
        <h4 {...remainingProperties} className={twMerge('text-xl', className)}>
          {children}
        </h4>
      );
    }
    case 'h5': {
      return (
        <h5 {...remainingProperties} className={twMerge('text-lg', className)}>
          {children}
        </h5>
      );
    }
    case 'h6': {
      return (
        <h6
          {...remainingProperties}
          className={twMerge('text-base', className)}
        >
          {children}
        </h6>
      );
    }
    default: {
      return (
        <h1 {...remainingProperties} className={twMerge('text-4xl', className)}>
          {children}
        </h1>
      );
    }
  }
};

export default Header;
